import React, { useEffect, useRef } from "react";
import _ from "lodash";
import "./footer.css";
import List from "../list/list";
import SocialLinks from "./footerSocial/footerSocial";
import NewsLetterForm from "../newsLetter/newsLetter";
import { LOGONBG } from "../images";
import FooterPrivacy from "./footerPrivacy";
import Divider from "../divider/divider";
import { version } from "../../../package.json";

console.log("APP VERSION", version);
const Footer = (props) => {
  const { footerItems, location, variant = "tall", fixed = false } = props;
  const footerRef = useRef(null);

  // Measure footer height and expose CSS var for layouts
  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }
    const measureHeight = () => {
      if (footerRef.current) {
        const rect = footerRef.current.getBoundingClientRect();
        const computedStyle = window.getComputedStyle(footerRef.current);
        const marginTop = parseFloat(computedStyle.marginTop) || 0;
        const marginBottom = parseFloat(computedStyle.marginBottom) || 0;
        const height = rect.height + marginTop + marginBottom;
        try {
          document.documentElement.style.setProperty(
            "--app-footer-height",
            `${height}px`
          );
        } catch (e) {}
      }
    };
    measureHeight();
    const timer = setTimeout(measureHeight, 100);
    window.addEventListener("resize", measureHeight);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", measureHeight);
    };
  }, [variant, fixed]);

  // Lift the floating buttons (Quick Start, scroll-to-top, ...) by the part of the
  // footer that is on screen, so they never sit on top of the footer links.
  useEffect(() => {
    if (typeof window === "undefined" || !footerRef.current) {
      return undefined;
    }
    const footerEl = footerRef.current;
    let frame = null;
    const updateOffset = () => {
      frame = null;
      const visible = Math.max(
        0,
        window.innerHeight - footerEl.getBoundingClientRect().top
      );
      document.documentElement.style.setProperty(
        "--fab-footer-offset",
        `${Math.round(visible)}px`
      );
    };
    const scheduleUpdate = () => {
      if (frame === null) frame = window.requestAnimationFrame(updateOffset);
    };
    updateOffset();
    window.addEventListener("scroll", scheduleUpdate, { passive: true });
    window.addEventListener("resize", scheduleUpdate);
    let observer;
    if (typeof ResizeObserver !== "undefined") {
      observer = new ResizeObserver(scheduleUpdate);
      observer.observe(document.body);
    }
    return () => {
      window.removeEventListener("scroll", scheduleUpdate);
      window.removeEventListener("resize", scheduleUpdate);
      if (observer) observer.disconnect();
      if (frame !== null) window.cancelAnimationFrame(frame);
      document.documentElement.style.removeProperty("--fab-footer-offset");
    };
  }, [variant, fixed]);

  return (
    <footer ref={footerRef} className={fixed ? "footer-fixed" : ""}>
      <div className={`container footer footer--${variant}`}>
        <Divider />
        <div className="footer-elements ">
          <div className="footer-right">
            <div className="col-box footer-wrapper">
              <div className="box nbg_logo desktopFooterLogo">
                <img alt="Logo" src={LOGONBG} />
                {variant == "short" && (
                  <div className="footer content">
                    Copyright © {new Date().getFullYear()} National Bank of
                    Greece. All rights reserved.
                  </div>
                )}
              </div>
              <div className="box options">
                {footerItems && footerItems.length > 0 && (
                  <List
                    className="footer-menu"
                    // $FlowFixMe
                    items={_.flatMap(
                      footerItems,
                      (footerItem) => footerItem.uris
                    )}
                  />
                )}
                <SocialLinks />
              </div>
              <div className="footer content">
                <div>
                  <small>Version {version}</small>
                </div>

                <div>
                  <FooterPrivacy />
                </div>
              </div>

              <div
                className="box nbg_logo mobileFooterLogo"
                style={{ display: "none" }}
              >
                <img src={LOGONBG} alt="logo" />
              </div>
            </div>
          </div>
        </div>
        <Divider />
      </div>
      <div className="container afterfooter"></div>
    </footer>
  );
};

export default Footer;
